import React, { Component } from "react";
import './socialSection.css';

class SocialSection extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="socialRoot">
                <div className="socialWrapper">
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>

                    <h1>Social Media</h1>
                    <div className="hl"></div>
                    <div className="social-link-container">
                        <a href="https://www.facebook.com/sexpunktnull" className="fa fa-facebook facebook-btn"></a>
                        <div className="separator"></div>
                        <a href="https://www.youtube.com/channel/UCdbTt4iJK0flwTghkJIBaZg" className="fa fa-youtube youtube-btn"></a>
                    </div>
                </div>
            </div>
        );
    }
}
export default SocialSection;